import { makeStyles } from '@material-ui/core';
import { icon_checkOutCheckInIcon, icon_checkOutCheckInIconUnChecked } from '../../assets/images/images';

interface Props {
    selected: boolean 
}

const useStyles = makeStyles((theme: any) => ({
    checkBoxContainer: {
        cursor: 'pointer'
    },  
}));


export const CustomCheckBox: React.FC<Props> = ({selected}) => {
    const classes = useStyles();

    return (
        <div>
            {selected ? 
                 <img src={icon_checkOutCheckInIcon} alt="checkOutCheckInIcon"/>
                : 
                <img src={icon_checkOutCheckInIconUnChecked} alt="checkOutCheckInIconUnChecked"/>
            }
        </div>
    );
}